// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+6kB5","heading":"styles_heading__E38DC","customSkeleton":"styles_customSkeleton__ro4Yj"};